/**
 * AdminFocusPanel — what an ops admin needs to ACTION today.
 */
import React from 'react';
import { FocusCard, FocusHero } from './FocusCard';

export function AdminFocusPanel({ focus }) {
  const blocks = focus?.blocks || [];
  const byKey = Object.fromEntries(blocks.map((b) => [b.key, b]));

  return (
    <div className="space-y-6" data-testid="admin-focus-panel">
      <FocusHero
        title="Operations triage queue."
        subtitle="Incidents, escalations, and safety reports come first — everything else lives under the full dashboard."
        primaryAction={focus?.primary_action}
      />

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <FocusCard
          block={byKey.incidents_open}
          testIdPrefix="admin-focus"
          emptyHint="No open incidents."
        />
        <FocusCard
          block={byKey.referrals_escalated}
          testIdPrefix="admin-focus"
          emptyHint="No referrals escalated."
        />
        <FocusCard
          block={byKey.provider_reports_unread}
          testIdPrefix="admin-focus"
          emptyHint="No safety reports pending."
        />
      </div>
    </div>
  );
}
